module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"receipts":"Belege","noReceiptsAvailable":"Keine Belege vorhanden"},"en":{"receipts":"Receipts","noReceiptsAvailable":"No receipts available"}}')
  delete Component.options._Ctor
}
